import React, { FC } from 'react';
import Checkbox from 'atomic/form/checkbox';
import Icon from 'atomic/icon';
import { OptionDataInterface } from 'modules/product/views/components/product-offers-header/interfaces/option.data.interface';
import './product-offers-filter-checkbox.scss';

interface ProductOffersFilterCheckboxProps {
    filter: OptionDataInterface;
    onFilterChange: (filter: OptionDataInterface) => void;
    isChecked?: boolean;
    count?: number;
}

const ProductOffersFilterCheckbox: FC<ProductOffersFilterCheckboxProps> = ({
    filter,
    onFilterChange,
    isChecked,
    count
}) => {
    const onFilter = (): void => {
        onFilterChange(filter);
    };

    return (
        <div className="product-offers-filter-checkbox">
            <Checkbox
                label={(
                    <span className="product-offers-filter-checkbox__label">
                        {filter.label}
                        {filter.icon && (
                            <Icon
                                className={filter.className}
                                name={filter.icon}
                                size={16}
                                color="primary"
                            />
                        )}
                        {Boolean(count) && (
                            <span className="product-offers-filter-checkbox__count">({count})</span>
                        )}
                    </span>
                )}
                value={filter.value}
                id={filter.value}
                checked={isChecked}
                disabled={!count}
                onChange={onFilter}
            />
        </div>
    );
};

export default ProductOffersFilterCheckbox;
